const __vite__mapDeps=(i,m=__vite__mapDeps,d=(m.f||(m.f=["vendors.js","liquid-renderer.js"])))=>i.map(i=>d[i]);
import { _ as __vitePreload } from "./preload-helper.js";
(async () => {
  const { Liquid, LiquidRenderer } = await __vitePreload(async () => {
    const { Liquid: Liquid2, LiquidRenderer: LiquidRenderer2 } = await import("./vendors.js");
    return { Liquid: Liquid2, LiquidRenderer: LiquidRenderer2 };
  }, true ? __vite__mapDeps([0,1]) : void 0);
  const engine = new Liquid();
  const REQUIRED_ELEMENTS = {
    storesListContainer: ".js-stores-list",
    geolocationButton: ".js-geolocation"
  };
  class StoreLocator extends HTMLElement {
    constructor() {
      super();
      for (let attribute in REQUIRED_ELEMENTS) {
        if (typeof document.querySelector(REQUIRED_ELEMENTS[attribute]) === "undefined") {
          throw new Error(REQUIRED_ELEMENTS[attribute] + " is undefined. Cannot initialize store locator");
        }
        this[attribute] = document.querySelector(REQUIRED_ELEMENTS[attribute]);
      }
      this.bindEvents = this.bindEvents.bind(this);
      this.results = {};
      this.resultsEl = this;
      this.mapToken = window.settings.store_locator.token;
      this.countriesToDisplay = window.settings.store_locator.countries_to_display;
      this.csv = window.settings.store_locator.file;
      this.default_long = window.settings.store_locator.long;
      this.default_lat = window.settings.store_locator.lat;
      this.default_zoom = window.settings.store_locator.zoom;
      this.marker_image = window.settings.store_locator.marker_image;
      this.marker_zoom = window.settings.store_locator.marker_zoom;
      this.colorPrimary = "#FFFFFF";
      this.map = null;
      this.clustersId = "clusters";
      this.storeMarkerId = "unclustered-point";
      this.imageMarkerId = "store";
      this.hasMap = window.settings.store_locator.has_map;
      this.ROUTE_URL = "https://www.google.com/maps/dir/?api=1";
      this.geoJsonStores = { "type": "FeatureCollection" };
      this.geoJsonStores.features = [];
      this.store = [];
      this.storeElements = [];
      this.liquidRenderer = new LiquidRenderer(engine);
      this.bindEvents();
    }
    bindEvents() {
      this.initialize();
    }
    initMap() {
      mapboxgl.accessToken = this.mapToken;
      this.map = new mapboxgl.Map({
        container: "map",
        style: "mapbox://styles/mapbox/light-v10",
        center: [2.3522219, 48.856614],
        zoom: 11
      });
      this.map.addControl(new mapboxgl.NavigationControl());
      this.map.on("load", () => {
        this.map.addSource("stores", {
          type: "geojson",
          data: this.geoJsonStores,
          cluster: true,
          clusterMaxZoom: 30,
          clusterRadius: 40
        });
        this.map.loadImage(this.marker_image, (error, image) => {
          if (error) throw error;
          this.map.addImage(this.imageMarkerId, image, {
            pixelRatio: 1
          });
        });
        this.addCluster();
        this.addStoreMarkers();
        this.initClickOnClusters();
        this.initClickOnStoreMarkers();
        this.initGeocoder();
        this.initGeolocation();
      });
    }
    initGeocoder() {
      const geocoder = new MapboxGeocoder({
        accessToken: this.mapToken,
        // Set the access token
        language: `${Shopify.locale}-${Shopify.locale.toUpperCase()}`,
        mapboxgl,
        // Set the mapbox-gl instance
        trackProximity: true,
        countries: this.countriesToDisplay,
        types: "place,locality,neighborhood,region,postcode,country,address",
        marker: {
          color: "#A0C7FD"
        },
        flyTo: {
          speed: 2.7
        }
      });
      document.querySelector("#geocoder").appendChild(geocoder.onAdd(this.map));
      const searchInput = document.querySelector("#geocoder .mapboxgl-ctrl-geocoder--input");
      searchInput.placeholder = window.translations.store_locator.search_placeholder;
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      if (params.q && params.q != "") {
        searchInput.value = params.q;
        geocoder.query(searchInput.value);
      }
      const searchInputButtonSubmit = document.querySelector("#geocoder button[type=submit]");
      searchInputButtonSubmit.addEventListener("click", () => {
        geocoder.query(searchInput.value);
        const suggestionsElement = document.querySelector(".mapboxgl-ctrl-geocoder .suggestions");
        setTimeout(() => {
          suggestionsElement.style.display = "none";
        }, 200);
      });
      searchInput.addEventListener("keydown", (e) => {
        if (e.key == "Enter" || e.key == 13) {
          const listOfSuggestions = document.querySelectorAll(".mapboxgl-ctrl-geocoder .suggestions li");
          if (listOfSuggestions || listOfSuggestions.length == 0) {
            geocoder.query(searchInput.value);
          }
          const suggestionsElement = document.querySelector(".mapboxgl-ctrl-geocoder .suggestions");
          setTimeout(() => {
            suggestionsElement.style.display = "none";
          }, 200);
        }
      });
      geocoder.on("result", (event) => {
        const searchResult = event.result.geometry;
        const placeType = event.result.place_type[0];
        if (placeType == "neighborhood" || placeType == "address" || placeType == "poi") {
          this.centerMap(searchResult.coordinates, 13);
        }
      });
    }
    initGeolocation() {
      let geolocate = new mapboxgl.GeolocateControl({
        positionOptions: {
          enableHighAccuracy: true
        },
        trackUserLocation: false
      });
      this.map.addControl(geolocate);
      geolocate.on("geolocate", (e) => {
        this.centerMap([e.coords.longitude, e.coords.latitude], 12);
      });
      if (this.geolocationButton) {
        this.geolocationButton.addEventListener("click", (e) => {
          e.preventDefault();
          if (!this.mapGeolocationButton) this.mapGeolocationButton = document.querySelector(".mapboxgl-ctrl-geolocate");
          if (this.mapGeolocationButton) {
            this.mapGeolocationButton.click();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }
        });
      }
    }
    initClickOnStoreMarkers() {
      this.map.on("click", this.storeMarkerId, (e) => {
        const store = e.features[0].properties;
        this.centerMap([store.long, store.lat], this.marker_zoom);
        this.displayMapboxPopupForStore(e.features[0].properties);
      });
    }
    initClickOnClusters() {
      this.map.on("click", this.clustersId, (e) => {
        const features = this.map.queryRenderedFeatures(e.point, { layers: [this.clustersId] });
        const clusterId = features[0].properties.cluster_id;
        this.map.getSource("stores").getClusterExpansionZoom(clusterId, (err, zoom) => {
          if (err) return;
          this.centerMap(features[0].geometry.coordinates, zoom);
        });
      });
    }
    displayMapboxPopupForStore(store) {
      const popupHTML = this.liquidRenderer.render("store-popup", store);
      const popup = new mapboxgl.Popup().setLngLat([store.long, store.lat]).setHTML(popupHTML).addTo(this.map);
      const openRouteButton = popup._container.querySelector(".js-open-route");
      if (openRouteButton) {
        openRouteButton.addEventListener("click", (e) => {
          const destinationEncoded = encodeURI(openRouteButton.dataset.routeAddress);
          window.open(this.ROUTE_URL + "&destination=" + destinationEncoded);
        });
      }
    }
    loadStores(onCompleteCallback) {
      Papa.parse(this.csv, {
        download: true,
        header: true,
        dynamicTyping: true,
        skipEmptyLines: true,
        complete: (json) => {
          if (typeof onCompleteCallback === "function") {
            onCompleteCallback(json);
          }
        }
      });
    }
    /**
     * Initialize instancied StoreLocator
     */
    initialize() {
      const onCompleteCallback = (json) => {
        this.jsonStores = json.data;
        this.jsonStores.forEach((store, index) => {
          if (typeof store.city == "string") {
            if (store.type == "store") {
              const destinationEncoded = encodeURI(store.street + " " + store.city + " " + store.zip);
              store.id = index.toString();
              store.searchTitle = store.name.toLowerCase().trim();
              store.searchCity = store.city.toLowerCase().trim();
              store.searchZip = store.zip?.toString().trim();
              store.hasMap = this.hasMap;
              store.index = index;
              store.route = this.ROUTE_URL + "&destination=" + destinationEncoded;
              const storeHTMLDocument = this.getStoreElement(store);
              const storeEl = storeHTMLDocument.querySelector(".store");
              const arrayDay = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
              this.storesListContainer.insertAdjacentElement("afterbegin", storeEl);
              storeEl.classList.add("store--visible");
              const date = /* @__PURE__ */ new Date();
              const day = date.getDay();
              let openingHours = store[arrayDay[day]];
              if (openingHours != null) {
                openingHours = openingHours.replace(/\s/g, "");
                storeEl.dataset.open = openingHours;
              } else {
                storeEl.dataset.open = "closed";
              }
              this.initializeOpenStatus(storeEl, day);
              this.geoJsonStores.features.push({
                type: "Feature",
                geometry: {
                  type: "Point",
                  coordinates: [store.long, store.lat]
                },
                properties: {
                  title: store.name,
                  ...store,
                  forSearch: store.name + "  " + store.city.toLowerCase() + " " + store.zip
                }
              });
            }
          }
        });
        if (this.hasMap) {
          this.initMap();
        }
      };
      this.loadStores(onCompleteCallback);
    }
    addStoreMarkers() {
      this.map.addLayer({
        id: this.storeMarkerId,
        type: "symbol",
        source: "stores",
        filter: ["!", ["has", "point_count"]],
        layout: {
          "icon-allow-overlap": true,
          "icon-image": ["get", "type"],
          "icon-anchor": "bottom"
        }
      });
    }
    addCluster() {
      this.map.addLayer({
        id: this.clustersId,
        type: "circle",
        source: "stores",
        filter: ["has", "point_count"],
        paint: {
          "circle-color": this.colorPrimary,
          "circle-radius": 18
        }
      });
      this.map.addLayer({
        id: "cluster-count",
        type: "symbol",
        source: "stores",
        filter: ["has", "point_count"],
        layout: {
          "text-field": "{point_count_abbreviated}",
          "text-font": ["Arial Unicode MS Bold"],
          "text-size": 14
        },
        paint: {
          "text-color": "#000000"
        }
      });
    }
    centerMap(positions, zoom) {
      this.map.flyTo({
        center: positions,
        zoom,
        speed: 1,
        curve: 2
      });
    }
    initializeOpenStatus(element) {
      const IS_OPEN = 1;
      const IS_CLOSED = 0;
      if (!element.classList.contains("js-open-status") || typeof element.dataset.open === "undefined") {
        throw new Error("Invalid .js-open-status element");
      }
      const date = /* @__PURE__ */ new Date();
      const now = date.getHours() * 60 + date.getMinutes();
      let isOpen = 0;
      if (element.dataset.open == "closed" || element.dataset.open == "Fermé") {
        isOpen = IS_CLOSED;
        element.querySelector(".js-opening-hours").innerText = window.translations.store_locator.closed_today.replace("&#39;", "'");
      } else {
        const openingHours = this.parseOpeningHours(element.dataset.open);
        let storeHasLunchbreak = false;
        Object.keys(openingHours).length == 4 ? storeHasLunchbreak = true : storeHasLunchbreak = false;
        if (!storeHasLunchbreak) {
          const start = openingHours.start.hours * 60 + openingHours.start.minutes;
          const end = openingHours.end.hours * 60 + openingHours.end.minutes;
          if (start <= now && now <= end) {
            isOpen = IS_OPEN;
          } else {
            isOpen = IS_CLOSED;
          }
        } else {
          const start = openingHours.start.hours * 60 + openingHours.start.minutes;
          const end = openingHours.end.hours * 60 + openingHours.end.minutes;
          const pauseStart = openingHours.pauseStart.hours * 60 + openingHours.pauseStart.minutes;
          const pauseEnd = openingHours.pauseEnd.hours * 60 + openingHours.pauseEnd.minutes;
          if (start <= now && now <= end) {
            if (pauseStart <= now && now <= pauseEnd) {
              isOpen = IS_CLOSED;
            } else {
              isOpen = IS_OPEN;
            }
          } else {
            isOpen = IS_CLOSED;
          }
        }
        element.querySelector(".js-opening-hours").innerText = window.translations.store_locator.schedules_today.replace("&#39;", "'") + " " + element.dataset.open;
      }
      element.querySelector(".js-open-status-info").classList.add(isOpen ? "open" : "closed");
    }
    parseOpeningHours(openingHoursString) {
      let daysParts = [];
      let openingHours = {};
      if (openingHoursString.includes("/")) {
        daysParts = openingHoursString.split("/");
        for (let i = 0; i < daysParts.length; i++) {
          const hoursParts = daysParts[i].split("-").map((range) => {
            let hoursAndMinutes = "";
            if (range.includes("h")) {
              hoursAndMinutes = range.split("h");
            } else if (range.includes("H")) {
              hoursAndMinutes = range.split("H");
            }
            return {
              "hours": hoursAndMinutes[0],
              "minutes": hoursAndMinutes[1]
            };
          });
          if (i == 0) {
            openingHours["start"] = {
              "hours": parseInt(hoursParts[0].hours),
              "minutes": parseInt(hoursParts[0].minutes)
            };
            openingHours["pauseStart"] = {
              "hours": parseInt(hoursParts[1].hours),
              "minutes": parseInt(hoursParts[1].minutes)
            };
          } else {
            openingHours["pauseEnd"] = {
              "hours": parseInt(hoursParts[0].hours),
              "minutes": parseInt(hoursParts[0].minutes)
            };
            openingHours["end"] = {
              "hours": parseInt(hoursParts[1].hours),
              "minutes": parseInt(hoursParts[1].minutes)
            };
          }
        }
      } else {
        const hoursParts = openingHoursString.split("-").map((range) => {
          let hoursAndMinutes = "";
          if (range.includes("h")) {
            hoursAndMinutes = range.split("h");
          } else if (range.includes("H")) {
            hoursAndMinutes = range.split("H");
          }
          return {
            "hours": hoursAndMinutes[0],
            "minutes": hoursAndMinutes[1]
          };
        });
        openingHours = {
          "start": {
            "hours": parseInt(hoursParts[0].hours),
            "minutes": parseInt(hoursParts[0].minutes)
          },
          "end": {
            "hours": parseInt(hoursParts[1].hours),
            "minutes": parseInt(hoursParts[1].minutes)
          }
        };
      }
      return openingHours;
    }
    getStoreElement(store) {
      const element = this.liquidRenderer.render("store-element", store);
      return new DOMParser().parseFromString(element, "text/html");
    }
  }
  customElements.define("w3-store-locator", StoreLocator);
})();
